import { t } from 'locale';
import { MouseEvent as ReactMouseEvent } from 'react';

import { MarkDown } from 'components/MarkDown';
import { Button } from 'components/_V2/Button/Button';
import { FooterProps } from 'components/_V2/Footer/Footer';

import { config } from 'config';

import { localeKeys } from 'enums/localeKeys';

import { getPrivacyPolicyUrlAndTitle } from 'utils/url';

export const FooterPrivacyPolicy = ({ triggerModal }: Pick<FooterProps, 'triggerModal'>) => {
  const { pp: privacyPolicy } = config.oldBankLoginFormLinkIdsToModal;
  const { title: privacyPolicyTitle, url: privacyPolicyUrl } = getPrivacyPolicyUrlAndTitle(
    t(privacyPolicy)
  );

  const imprintTitle = t(localeKeys.textsImprintTitle);
  const imprintContent = t(localeKeys.textsImprint);

  const onClickImprint = () => {
    triggerModal({
      title: imprintTitle,
      children: <MarkDown text={imprintContent} htmlTag="div" />,
      options: {
        showCancel: true,
        showConfirm: false
      }
    });
  };

  const openLinkInNewTab = (event: ReactMouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    window.open(privacyPolicyUrl);
  };

  return (
    <div className="flex flex-row gap-3">
      <Button
        size="small"
        variant="tertiary"
        data-testid="footer-data-privacy-button"
        onClick={openLinkInNewTab}
        className="h-[28px] p-0 md:p-3"
      >
        {t(privacyPolicyTitle as keyof typeof localeKeys)}
      </Button>

      <Button
        size="small"
        variant="tertiary"
        data-testid="footer-imprint-button"
        onClick={onClickImprint}
        className="h-[28px] p-0 md:p-3"
      >
        {t(localeKeys.textsImprintTitle)}
      </Button>
    </div>
  );
};
